import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface FastAPIAddress {
  city: string;
  country: string;
  county: string;
  neighborhood: string;
  full_str: string;
  lat: number;
  lon: number;
  state: string;
  state_code: number;
  street_name: string;
  street_number: string;
  zip_code: string;
}

interface FastAPIAddressExtended extends FastAPIAddress {
  address: string;
}

interface GoogleAPIAddress {
  description: string;
  place_id: string;
}

interface FastAPIResponse {
  gc: any[]; // TODO: Correct it when defined
  google: GoogleAPIAddress[];
  osm: FastAPIAddress[];
}

@Injectable({
  providedIn: 'root'
})
class FastAPIService {
  constructor(private httpClient: HttpClient) {
  }

  lookup(searchString: string): Observable<FastAPIResponse> {
    return this.httpClient
      .get<FastAPIResponse>(`${environment.addressesSearch.fastAPIBase}/lookup?q=${searchString}`);
  }

  sendPlace(id: string): Observable<FastAPIAddressExtended> {
    return this.httpClient
      .get<FastAPIAddress>(`${environment.addressesSearch.fastAPIBase}/place_details?place_id=${id}`)
      .pipe(map(res =>({...res, address: res.full_str})));
  }
}

export { FastAPIResponse, FastAPIAddress, FastAPIAddressExtended, FastAPIService };
